module.exports = __webpack_public_path__ + "img/PredictiveMaintenance_mehrfarbig_RGB.664cbc8e.svg";